import React, {useCallback, useMemo} from 'react';
import _ from 'lodash'
import { isCapabilityEnabled } from '@xengage/gw-portals-config-js';
import { useTranslator } from '@jutro/locale';
import appConfig from 'app-config';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { withRouter } from 'react-router-dom';
import messages from './ManageClaims.messages';
import metadata from './ManageClaims.metadata.json5';
import styles from './ManageClaims.module.scss';


function ManageClaims(props) {
    const authData = useAuthentication();
    const authUserData = _.get(authData, 'authUserData');
    const noAuthorizations = authData?.noCurrentAuthorizations_TWIA;
    const isTFPA = authUserData?.associationName_TWIA === 'tfpa';
    const translate = useTranslator();
    const { capabilitiesConfig } = appConfig;
    
    const claimCapabilityCheck = useMemo(() => isCapabilityEnabled({
        capabilitiesConfig,
        capabilityName: 'fnol',
    }) && !noAuthorizations, [capabilitiesConfig]);

    const handleFileClaimClick = useCallback(
        () => () => {
            const { history } = props;
            const redirectPath = `/claims`;

            return history.push({
                pathname: '/fnol-select-policy',
                state: {
                    redirectPath,
                    claimData: { },
                },
            });
        },
        [props]
    );

    const override = {
        fileClaimButton: {
            onClick: handleFileClaimClick(),
            visible: claimCapabilityCheck,
        },
        manageClaimsNoteTFPA:{
            visible: isTFPA
        },
        manageClaimsNoteTWIA:{
            visible: !isTFPA
        },
        manageClaimsSubNote: {
            visible: claimCapabilityCheck,
        },
        noAuthorizationNotificationMessage: {
            linkProps: {
              children: translate(messages.noAuthoriziationLink),
              href: 'https://www.twia.org/cpp-account/',
              target: '_blank',
            },
            message: translate(messages.noAuthoriziationMessage),
            messageProps: { warning: translate(messages.noAuthoriziationHeader) },
        },
        noAuthorizationContainer: {
            visible: noAuthorizations === true,
        },
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {},
    };

    return (
        <MetadataContent
            uiProps={metadata.pageContent}
            overrideProps={override}
            {...resolvers}
        />
    );
}

export default withRouter(ManageClaims);
